import { render, staticRenderFns } from "./matching-card-background.vue?vue&type=template&id=6383ebee&scoped=true&"
import script from "./matching-card-background.vue?vue&type=script&lang=ts&"
export * from "./matching-card-background.vue?vue&type=script&lang=ts&"
import style0 from "./matching-card-background.vue?vue&type=style&index=0&id=6383ebee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6383ebee",
  null
  
)

export default component.exports